import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { OrganisationService } from '@sb-shared/services/organisation.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'sb-icon-svg-img',
    templateUrl: './icon-svg-img.component.html',
    styleUrls: ['./icon-svg-img.component.scss'],
    standalone: false
})
export class IconSvgImgComponent implements OnInit {
  @Input() imgUrl = '';
  fullImgUrl: string;
  color: string;

  constructor(
      private organisation: OrganisationService,
      ) { }

  ngOnInit(): void {
    this.organisation.getCurrentOrganisation().subscribe(org => {
      this.color = `#${org.darkColour ? org.darkColour : '000'}`;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const cdnBase = environment.cdnBase;

    // Generate url
    this.fullImgUrl = `${cdnBase}img/icons/${this.imgUrl}`;
  }

}
